<template>
  <div>
    <b-card-group deck>
      <b-card 
        v-for="(file,index) in items" 
        :key="index" 
        :title="file.title.rendered"
      >
        <!---<b-card-img v-for="(img,i) in file.featured_image_urls" :key="i" :src="img[0]"></b-card-img>--->
        <b-card-img :src="file.featured_image_urls.medium[0]" />
        <b-card-body v-html="file.excerpt.rendered" />
        {{ file.date | fromNow }}
      </b-card>
    </b-card-group>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "HelpFiles",
  data() {
    return {
      items: []
    };
  },
  mounted() {
    this.getFiles();
  },
  methods: {
    getFiles() {
      const url = "https://nosli.nl/wp-json/wp/v2/posts?categories[]=20";
      var vm = this;

      axios
        .get(url, {
          headers: {
            Authorization: `Bearer dkcyKcy1bxoRA19imVL65MZ7m03d3UpR`
          }
        })
        .then(function(response) {
          console.log(response);
          vm.items = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
};
</script>